import React from 'react';
import { Column } from 'primereact/column'

const MultipleSelectColumn = () => (
    <Column selectionMode="multiple" headerStyle={{
        width: '3em'
    }} />)


export default MultipleSelectColumn